<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">课程章节管理</span>

    <div class="bottom_div">
      <el-button
        size="mini"
        type="primary"
        icon="el-icon-plus"
        @click="add_course_but"
      >
        课程章节
      </el-button>

      <el-table :data="tableData" class="table" border stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="CreatedAt" label="日期"></el-table-column>
        <el-table-column prop="Name" label="图片">
          <template slot-scope="scope">
            <img :src="scope.row.UpdatedAt" style="width:100px;" />
          </template>
        </el-table-column>
        <el-table-column prop="belong_to" label="所属课程"></el-table-column>
        <el-table-column prop="Name" label="章节名称"></el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="editCampus(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_principal_button(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加课程课包弹框 -->
    <el-dialog
      :title="belong_to ? '修改课程课包' : '添加课程课包'"
      :visible.sync="add_course_subject"
      width="40%"
      :closeOnClickModal="false"
    >
      <el-form
        :inline="true"
        ref="formRef"
        :model="form"
        class="demo-form-inline"
      >
        <el-form-item
          label="上传图片"
          prop="image"
          :rules="[
            {
              required: true,
              message: '图片不能为空',
              trigger: ['change', 'blur'],
            },
          ]"
          style="display: block;"
        >
          <el-upload
            ref="removeUpload"
            class="upload-demo"
            :action="uploadURL"
            :on-success="upload_success"
            :on-remove="upload_remove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            style="width:100%;"
          >
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="!belong_to"
          style="width:100%;"
          label="课程"
          prop="Id"
          :rules="[{ required: true, message: '课程不能为空' }]"
        >
          <el-select v-model="form.Id" placeholder="请选择课程">
            <el-option
              v-for="item in subjectData"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-else style="width:100%;" label="课程">
          <el-input v-model="belong_to" disabled></el-input>
        </el-form-item>

        <el-form-item
          label="章节"
          prop="name"
          :rules="[{ required: true, message: '章节不能为空' }]"
        >
          <el-input
            placeholder="请输入课程章节名称"
            v-model="form.name"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="add_course_subject = false" size="mini"
          >取消</el-button
        >
        <el-button type="primary" @click="add_principal_frame" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";
import {
  getCourse,
  add_chapter_api,
  edit_chapter_api,
  delete_chapter_api,
} from "@/api/addAccount.js";
import {
  upload_resources_image_api,
  post_image_url_api,
} from "@/api/resources.js";

export default {
  computed: {
    ...mapGetters(["current"]),
  },
  components: {
    loading,
  },

  data() {
    return {
      add_course_subject: false, //添加课程科目弹框打开关闭
      tableData: [], //表格数据
      form: { image: "", Id: "", name: "" }, //表单数据
      subjectData: [],
      belong_to: "",
      uploadURL: "",
      loading_ok: "",
    };
  },

  created() {
    this.getCourse_but();
    this.uploadURL = upload_resources_image_api();
  },

  methods: {
    //获取课程
    getCourse_but() {
      getCourse(this.current).then((response) => {
        let value = response.data,
          array = [];

        if (value.length) {
          this.subjectData = value;
          this.form.Id = value[0].Id;
        }

        value.forEach((v) => {
          v.Chapters.forEach((val) => {
            val.belong_to = v.Name;
            array.push(val);
          });
        });

        array.forEach((v) => {
          v.CreatedAt = this.filters.vdateAdd(v.CreatedAt);
          post_image_url_api([v.Image]).then((res) => {
            v.UpdatedAt = "http://" + res.data[0];
          });
        });
        this.tableData = array;
        this.loading_ok = false;
      });
    },

    //添加课程章节按钮
    add_course_but() {
      this.form.Id = this.subjectData[0].Id;
      this.belong_to = "";
      this.form.name = "";
      this.add_course_subject = true;
    },

    // 表格修改按钮
    editCampus(item) {
      this.add_course_subject = true;
      this.form.name = item.Name;
      this.form.Id = item.Id;
      this.form.image = item.Image;
      this.belong_to = item.belong_to;
    },

    // 表格删除按钮
    delete_principal_button(item) {
      console.log(item);
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          delete_chapter_api(item.Id).then(() => {
            this.getCourse_but();
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    // 添加/修改课程章节弹框确定按钮
    add_principal_frame() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.belong_to) {
            edit_chapter_api(this.form.Id, {
              image: this.form.image,
              name: this.form.name,
            }).then(() => {
              this.getCourse_but();
              this.$message.success("修改成功！");
              this.add_course_subject = false;
            });
          } else {
            add_chapter_api(this.form.Id, {
              image: this.form.image,
              name: this.form.name,
            }).then(() => {
              this.getCourse_but();
              this.$message.success("添加成功！");
              this.add_course_subject = false;
            });
          }
        }
      });
    },

    // 上传成功钩子
    upload_success(res) {
      console.log(res.Url);
      this.form.image = res.Id;
    },

    // 移除上传文件钩子
    upload_remove() {
      this.form.image = "";
    },

    // 超出上传文件个数钩子
    handleExceed() {
      this.$message.error("目前仅支持上传单个文件");
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    .bottom_div {
      margin-top:30px;
    }
    .table {
      margin-top:16px;
    }
}
</style>
